import { render } from "./DeviceInformationTab.vue?vue&type=template&id=747ee573&ts=true"
import script from "./DeviceInformationTab.ts?vue&type=script&lang=ts"
export * from "./DeviceInformationTab.ts?vue&type=script&lang=ts"

import "./DeviceInformationTab.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__